export const topicCategories = [
  { id: "all", name: "全部风向", desc: "全网正在发酵的所有话题" },
  { id: "star", name: "明星动态", desc: "艺人行程、同框、互动引发的连锁讨论" },
  { id: "variety", name: "综艺现场", desc: "录制片段、剪辑争议与现场氛围话题" },
  { id: "screen", name: "影视片场", desc: "剧组拍摄、番位、宣发节奏相关话题" },
  { id: "storm", name: "网络风波", desc: "截图、账号动态与小作文引发的争议" },
  { id: "brand", name: "品牌代言", desc: "代言物料、海报调整与商业合作话题" },
  { id: "esports", name: "电竞圈", desc: "战队阵容、赛事争议与选手动态" },
  { id: "music", name: "音乐现场", desc: "演唱会、音乐节与歌单调整话题" },
];

export interface SpreadPoint {
  time: string;
  label: string;
  desc: string;
  heat: number;
}

export interface HotTopic {
  id: string;
  title: string;
  tag: "爆" | "热" | "沸" | "新" | "荐";
  categoryId: string;
  category: string;
  heat: number;
  shares: number;
  trend: "up" | "down" | "flat";
  trendValue: number;
  summary: string;
  scope: string[];
  highlight: string;
  peakTime: string;
  timeline: SpreadPoint[];
}

export const hotTopics: HotTopic[] = [
  {
    id: "topic-tongkuang",
    title: "某恋综嘉宾深夜同框被拍，话题一路被传疯",
    tag: "爆",
    categoryId: "variety",
    category: "综艺现场",
    heat: 3284000,
    shares: 486000,
    trend: "up",
    trendValue: 22,
    summary:
      "一段模糊的夜间同框画面先在小圈子里流传，随后被搬运、二创、配字，48 小时内多次冲上热搜，成为本周扩散最快的话题之一。",
    scope: ["短视频平台", "内容社区", "热搜榜", "社交转发"],
    highlight: "从爆料到登上热搜榜首仅用时 19 小时，是本季度出圈速度最快的综艺类话题。",
    peakTime: "话题发布后第 31 小时",
    timeline: [
      { time: "T+0h", label: "原始画面出现", desc: "一段低清晰度画面在私域群聊与小型社区中流出，尚未形成公开讨论。", heat: 12000 },
      { time: "T+6h", label: "搬运与配字", desc: "多个娱乐账号搬运并配上引导性文字，讨论开始向公开平台迁移。", heat: 186000 },
      { time: "T+19h", label: "首次登上热搜", desc: "话题首次进入热搜榜前十，转发量在一小时内翻了三倍。", heat: 1240000 },
      { time: "T+31h", label: "全网被传疯", desc: "短视频二创、合集剪辑集中发布，话题热度到达峰值并被大量转发。", heat: 3284000 },
      { time: "T+52h", label: "热度回落", desc: "缺少新的信息增量，讨论重心转向旧素材复盘，热度缓慢下降。", heat: 1600000 },
    ],
  },
  {
    id: "topic-pianchang",
    title: "某都市剧片场争议片段流出，转发量突破四百万",
    tag: "沸",
    categoryId: "screen",
    category: "影视片场",
    heat: 2760000,
    shares: 428000,
    trend: "up",
    trendValue: 15,
    summary:
      "一段未经证实的片场视频被反复剪辑传播，多个版本互相矛盾，却在短时间内累积了超过四百万次转发。",
    scope: ["短视频平台", "内容社区", "社交转发"],
    highlight: "同一条话题下出现了至少 6 个互相矛盾的版本，成为典型的“素材比事实跑得快”。",
    peakTime: "话题发布后第 26 小时",
    timeline: [
      { time: "T+0h", label: "片段首发", desc: "一段短暂的片场片段被上传，发布者未说明来源与时间。", heat: 34000 },
      { time: "T+9h", label: "版本分裂", desc: "不同账号给出互相矛盾的解释，讨论热度不降反升。", heat: 420000 },
      { time: "T+26h", label: "转发破四百万", desc: "合集类短视频集中发布，转发量快速累积至峰值。", heat: 2760000 },
      { time: "T+48h", label: "进入复盘阶段", desc: "讨论从事件本身转向“素材为何被误读”，热度平稳下降。", heat: 980000 },
    ],
  },
  {
    id: "topic-sixin",
    title: "某选秀出道偶像私信截图曝出，粉丝内部先炸锅",
    tag: "热",
    categoryId: "storm",
    category: "网络风波",
    heat: 1980000,
    shares: 316000,
    trend: "flat",
    trendValue: 3,
    summary:
      "一组无法核实的对话截图在粉丝社群内先行扩散，随后被搬运至公开平台，形成跨圈层讨论。",
    scope: ["内容社区", "社交转发", "热搜榜"],
    highlight: "话题的第一次爆发完全发生在粉丝社群内部，属于典型的“内圈先热、外圈后到”。",
    peakTime: "话题发布后第 22 小时",
    timeline: [
      { time: "T+0h", label: "社群里流出", desc: "截图在粉丝群中流传，讨论仅限小范围。", heat: 26000 },
      { time: "T+11h", label: "跨圈搬运", desc: "部分账号将截图搬运到公开社区，引发路人围观。", heat: 360000 },
      { time: "T+22h", label: "热度见顶", desc: "话题进入热搜中段位置，转发量稳定增长后趋于平缓。", heat: 1980000 },
    ],
  },
  {
    id: "topic-gedan",
    title: "某女歌手演唱会临时改歌单，现场观众反应两极",
    tag: "新",
    categoryId: "music",
    category: "音乐现场",
    heat: 1640000,
    shares: 208000,
    trend: "up",
    trendValue: 9,
    summary:
      "演出中途调整曲目顺序的细节被现场观众记录并发布，短时间内引发关于舞台编排的广泛讨论。",
    scope: ["短视频平台", "内容社区", "社交转发"],
    highlight: "现场短视频成为主要传播载体，音频片段被大量二次使用。",
    peakTime: "话题发布后第 14 小时",
    timeline: [
      { time: "T+0h", label: "现场记录发布", desc: "观众拍摄的短视频陆续上传，画面清晰度较高。", heat: 48000 },
      { time: "T+6h", label: "音频二创", desc: "现场音频被大量用于二次创作，话题扩散提速。", heat: 560000 },
      { time: "T+14h", label: "进入热搜", desc: "话题冲入热搜榜前列，成为当晚讨论度最高的演出话题。", heat: 1640000 },
    ],
  },
  {
    id: "topic-juben",
    title: "某综艺被逐帧分析，剧本痕迹成最大争议点",
    tag: "热",
    categoryId: "variety",
    category: "综艺现场",
    heat: 1420000,
    shares: 174000,
    trend: "down",
    trendValue: 6,
    summary:
      "观众自发整理出多组镜头对比，讨论节目剪辑与现场流程之间的出入，热度在两天后开始回落。",
    scope: ["内容社区", "短视频平台"],
    highlight: "由观众自发产出的对比内容成为话题主力，属于典型的“考据式扩散”。",
    peakTime: "话题发布后第 18 小时",
    timeline: [
      { time: "T+0h", label: "对比内容出现", desc: "有观众发布镜头对比图文，指出流程上的可疑之处。", heat: 30000 },
      { time: "T+8h", label: "考据扩散", desc: "更多用户加入逐帧分析，形成持续的 UGC 产出。", heat: 480000 },
      { time: "T+18h", label: "见顶回落", desc: "节目方未作更多回应，讨论热度逐步下降。", heat: 1420000 },
    ],
  },
  {
    id: "topic-haibao",
    title: "某品牌代言海报秒删重发，调整细节被放大解读",
    tag: "荐",
    categoryId: "brand",
    category: "品牌代言",
    heat: 1180000,
    shares: 96000,
    trend: "flat",
    trendValue: 2,
    summary:
      "品牌方对同一组物料进行了两次发布，前后差异被网友截图对比，引发关于合作状态的猜测。",
    scope: ["社交转发", "内容社区"],
    highlight: "话题切口很小，却依靠截图对比获得了超出预期的讨论量。",
    peakTime: "话题发布后第 10 小时",
    timeline: [
      { time: "T+0h", label: "物料出现差异", desc: "网友发现同一海报前后版本存在细节出入。", heat: 18000 },
      { time: "T+5h", label: "截图对比扩散", desc: "对比图在社交平台被快速转发。", heat: 320000 },
      { time: "T+10h", label: "讨论见顶", desc: "品牌方未进一步说明，话题热度维持在中位。", heat: 1180000 },
    ],
  },
  {
    id: "topic-zhuanhui",
    title: "某电竞战队临阵换人，粉丝讨论冲上热搜前列",
    tag: "爆",
    categoryId: "esports",
    category: "电竞圈",
    heat: 2310000,
    shares: 372000,
    trend: "up",
    trendValue: 18,
    summary:
      "赛前一小时公布的阵容调整让大量观众措手不及，相关讨论在比赛开始前就已完成一轮爆发式扩散。",
    scope: ["内容社区", "热搜榜", "社交转发", "短视频平台"],
    highlight: "话题热度几乎与赛事时间线同步攀升，属于“事件驱动型”扩散。",
    peakTime: "比赛开始后第 3 小时",
    timeline: [
      { time: "T-1h", label: "阵容公布", desc: "官方公布调整后的首发阵容，讨论立即升温。", heat: 62000 },
      { time: "T+0h", label: "比赛开始", desc: "直播间弹幕与社交平台讨论同步放大。", heat: 760000 },
      { time: "T+3h", label: "冲上热搜前列", desc: "话题进入热搜榜前列，转发量快速累积。", heat: 2310000 },
    ],
  },
  {
    id: "topic-zhuangshan",
    title: "某时尚红毯撞衫名场面合集，被剪成多个版本传播",
    tag: "热",
    categoryId: "star",
    category: "明星动态",
    heat: 1060000,
    shares: 128000,
    trend: "flat",
    trendValue: 1,
    summary:
      "活动结束后，网友将红毯造型整理成合集，相似造型的并列对比成为主要传播形式。",
    scope: ["短视频平台", "内容社区"],
    highlight: "纯视觉类话题依靠合集剪辑维持了较长的讨论周期。",
    peakTime: "活动结束后第 6 小时",
    timeline: [
      { time: "T+0h", label: "造型图流出", desc: "活动精修图陆续发布，开始出现造型对比讨论。", heat: 44000 },
      { time: "T+6h", label: "合集剪辑上线", desc: "多个撞衫合集被剪辑发布，成为话题主力内容。", heat: 1060000 },
    ],
  },
  {
    id: "topic-quguan",
    title: "某演员取关事件时间线被整理，网友复盘互动轨迹",
    tag: "新",
    categoryId: "storm",
    category: "网络风波",
    heat: 920000,
    shares: 84000,
    trend: "down",
    trendValue: 4,
    summary:
      "账号关注列表的变化被网友记录并整理成时间线，形成一轮围绕互动关系的复盘式讨论。",
    scope: ["内容社区", "社交转发"],
    highlight: "话题完全由网友自行整理的时间线驱动，几乎没有官方信息介入。",
    peakTime: "话题发布后第 12 小时",
    timeline: [
      { time: "T+0h", label: "关注变化被记录", desc: "有用户发现关注列表发生变化并截图留存。", heat: 15000 },
      { time: "T+12h", label: "时间线整理", desc: "多个版本的时间线被整理发布，讨论达到峰值。", heat: 920000 },
    ],
  },
  {
    id: "topic-huiguo",
    title: "某团体回锅肉争议再起，过往舞台被重新翻出",
    tag: "沸",
    categoryId: "variety",
    category: "综艺现场",
    heat: 1750000,
    shares: 244000,
    trend: "up",
    trendValue: 11,
    summary:
      "新一轮节目名单公布后，围绕阵容构成的讨论迅速升温，大量过往舞台片段被重新传播。",
    scope: ["短视频平台", "内容社区", "热搜榜"],
    highlight: "旧素材因为新事件被重新激活，是典型的“话题回流”现象。",
    peakTime: "名单公布后第 16 小时",
    timeline: [
      { time: "T+0h", label: "名单公布", desc: "节目组公布新一轮录制名单，讨论开始聚集。", heat: 38000 },
      { time: "T+16h", label: "旧素材回流", desc: "过往舞台片段被大量翻出重发，话题热度见顶。", heat: 1750000 },
    ],
  },
  {
    id: "topic-fanwei",
    title: "某剧组官宣海报排序引讨论，番位话题再次上榜",
    tag: "热",
    categoryId: "screen",
    category: "影视片场",
    heat: 1360000,
    shares: 152000,
    trend: "flat",
    trendValue: 2,
    summary:
      "海报上的名字排布被逐行解读，讨论很快从视觉延伸到对合作关系的各种推测。",
    scope: ["内容社区", "社交转发"],
    highlight: "话题切口高度符号化，靠细节解读维持讨论热度。",
    peakTime: "官宣后第 9 小时",
    timeline: [
      { time: "T+0h", label: "海报发布", desc: "剧组发布定档海报，网友开始解读排布细节。", heat: 52000 },
      { time: "T+9h", label: "解读扩散", desc: "多篇解读图文集中出现，话题进入热搜中段。", heat: 1360000 },
    ],
  },
  {
    id: "topic-yazhou",
    title: "某音乐节压轴顺序调整，现场观演体验成讨论焦点",
    tag: "荐",
    categoryId: "music",
    category: "音乐现场",
    heat: 880000,
    shares: 76000,
    trend: "flat",
    trendValue: 1,
    summary:
      "演出顺序临时调整后，现场观众的记录被陆续上传，讨论集中在观演体验与流程安排上。",
    scope: ["短视频平台", "社交转发"],
    highlight: "话题体量不大，却拥有很高的现场真实感素材比例。",
    peakTime: "演出结束后第 4 小时",
    timeline: [
      { time: "T+0h", label: "顺序调整", desc: "现场公布调整后的出场顺序，观众记录陆续上传。", heat: 24000 },
      { time: "T+4h", label: "体验讨论", desc: "围绕现场体验的讨论集中出现，热度到达峰值。", heat: 880000 },
    ],
  },
];

export const getTopicById = (id: string) => hotTopics.find((item) => item.id === id);

export const trendingTicker = hotTopics
  .slice(0, 8)
  .map((item) => `${item.tag} ${item.title} · 转发 ${(item.shares / 10000).toFixed(1)}万`);